import * as React from 'react';

/**
 * Whether a CSS media query matches, as React state.
 *
 * Most responsive work here is a Tailwind prefix and needs no JavaScript. This
 * exists for the cases where the viewport changes a *component's behaviour* and
 * not only its look: vertical tabs answer arrow keys up and down, so a layout
 * that turns them into a row on a phone has to say so to Radix as well, or the
 * keyboard keeps navigating the axis nobody can see.
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = React.useCallback(
    (onChange: () => void) => {
      const list = globalThis.matchMedia?.(query);
      list?.addEventListener('change', onChange);
      return () => list?.removeEventListener('change', onChange);
    },
    [query],
  );

  return React.useSyncExternalStore(
    subscribe,
    () => globalThis.matchMedia?.(query).matches ?? false,
    // No server rendering here, but the same answer is the right default: a
    // narrow viewport is the one that degrades gracefully if it is wrong.
    () => false,
  );
}

/** Below `md`, where the shell already switches to one pane at a time (U1). */
export function useIsCompact(): boolean {
  return !useMediaQuery('(min-width: 48rem)');
}
